import React from 'react';
import { Navigate } from 'react-router-dom';

function isJwtExpired(token) {
  try {
    const parts = token.split('.');
    if (parts.length !== 3) return null; // not a JWT
    const payload = JSON.parse(atob(parts[1].replace(/-/g, '+').replace(/_/g, '/')));
    if (!payload || !payload.exp) return null;
    const nowSec = Math.floor(Date.now() / 1000);
    return payload.exp < nowSec;
  } catch (e) {
    return null;
  }
}

const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  if (!token) return <Navigate to="/" replace />;

  const expired = isJwtExpired(token);
  if (expired === true) {
    // token is a JWT and expired
    localStorage.removeItem('token');
    return <Navigate to="/" replace />;
  }

  // expired === false -> token is JWT and valid
  // expired === null  -> token is not a parseable JWT; keep legacy behavior (presence check)
  return children;
};

export default ProtectedRoute;
